import styled from 'styled-components/native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {RFValue} from 'react-native-responsive-fontsize';

export const Btn = styled.TouchableOpacity<{active?: boolean}>`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  background-color: ${({active, theme}) => (active ? theme.colors.header_icon_background : theme.colors.header_icon_background)};
  border-radius: ${RFValue(32)}px;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled(MaterialCommunityIcons)<{active?: boolean}>`
  font-size: ${RFValue(16)}px;
  color: ${({active, theme}) => (active ? theme.colors.header_icon_color : theme.colors.header_icon_color)};
`;

export const HeaderIconButtonsRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(8)}px;
`;
